import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { PolicyFooter } from './legal/PolicyLayout';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(location.state?.user ? true : null);

  useEffect(() => {
    if (location.state?.user) return;
    if (!loading) {
      setIsAuthenticated(user ? true : false);
    }
  }, [user, loading, location.state]);

  if (loading || isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && user?.role !== requiredRole) {
    if (user?.role === 'buyer') return <Navigate to="/buyer-dashboard" replace />;
    if (user?.role === 'supplier') return <Navigate to="/supplier-dashboard" replace />;
    if (user?.role === 'admin') return <Navigate to="/admin-dashboard" replace />;
    if (user?.role === 'referral_partner' || user?.role === 'dsa') return <Navigate to="/partner-dashboard" replace />;
    if (user?.role === 'committee_member') return <Navigate to="/committee/dashboard" replace />;
    if (user?.role === 'committee_observer') return <Navigate to="/observer/dashboard" replace />;
    return <Navigate to="/" replace />;
  }

  return (
    <>
      {children}
      <PolicyFooter />
    </>
  );
};

export default ProtectedRoute;
